import { useElementSize } from "@vueuse/core";
import { Ref, computed, ref } from "vue";
import { XYCoords } from "@/store/annotation-v2/state";

export const useCursorRenderer = (boardRef: Ref<HTMLDivElement | undefined>, pointerRef?: Ref<XYCoords | null | undefined>) => {
  const scaleRatio = ref(1);
  const containerSize = useElementSize(boardRef);
  const defaultCursorSize = 0.055;

  const pointerStyle = computed(() => {
    const pointer = pointerRef?.value;
    // Hide cursor if null, undefined, or special hide value (-1, -1)
    if (!pointer || (pointer.x === -1 && pointer.y === -1)) {
      return "display: none";
    }
    return `transform: translate(${pointer.x * scaleRatio.value}px, ${pointer.y * scaleRatio.value}px); width: ${
      defaultCursorSize * containerSize.width.value
    }px; height: ${defaultCursorSize * containerSize.height.value}px;`;
  });

  return { pointerStyle, scaleRatio };
};
